import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import ClerkAuthProvider from "@/components/auth/ClerkAuthProvider";
import { ShopProvider } from "@/lib/store";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import Product from "@/pages/Product";
import Anime from "@/pages/Anime";
import CustomPrinting from "@/pages/CustomPrinting";
import UploadDesign from "@/pages/UploadDesign";
import Wholesale from "@/pages/Wholesale";
import Reels from "@/pages/Reels";
import Cart from "@/pages/Cart";
import Checkout from "@/pages/Checkout";
import { Orders, OrderDetail } from "@/pages/Orders";
import Wishlist from "@/pages/Wishlist";
import Contact from "@/pages/Contact";
import { SignInPage, SignUpPage } from "@/pages/Auth";
import Admin from "@/admin/Admin";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

export default function App() {
  return (
    <BrowserRouter>
      <ClerkAuthProvider>
        <ShopProvider>
          <ScrollTop />
          <Toaster theme="dark" position="bottom-right" toastOptions={{ style: { background: "#171717", border: "1px solid #2c2c2c", color: "#fff", borderRadius: 0 } }} />
          <Routes>
            <Route path="/admin/*" element={<Admin />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/shop" element={<Shop />} />
              <Route path="/shop/:category" element={<Shop />} />
              <Route path="/product/:slug" element={<Product />} />
              <Route path="/anime-after-dark" element={<Anime />} />
              <Route path="/custom-printing" element={<CustomPrinting />} />
              <Route path="/upload-design" element={<UploadDesign />} />
              <Route path="/wholesale" element={<Wholesale />} />
              <Route path="/reels" element={<Reels />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/orders" element={<Orders />} />
              <Route path="/orders/:id" element={<OrderDetail />} />
              <Route path="/wishlist" element={<Wishlist />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/sign-in/*" element={<SignInPage />} />
              <Route path="/sign-up/*" element={<SignUpPage />} />
              <Route path="*" element={<div className="min-h-[60vh] grid place-items-center font-display text-5xl" data-testid="not-found">404 — LOST IN THE DEN</div>} />
            </Route>
          </Routes>
        </ShopProvider>
      </ClerkAuthProvider>
    </BrowserRouter>
  );
}
